import { Box, Flex, Heading } from '@chakra-ui/react';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import useGetPendingExecutions from './useGetPendingExecutions';
import CampaignExecutionCard from './components/CampaignExecutionCard';
import AllPendingExecutionDialog from './components/AllPendingExecutionsDialog';

const CampaignExecution = () => {
  const {
    getCampaignExecutionList,
    campaignExecutionList,
    loading,
    totalPages,
  } = useGetList();

  const {
    showAllPendingExecutionsDialog,
    closeAllPendingExecutionsDialog,
    pendingExecutionDetails,
  } = useGetPendingExecutions();

  const getCurrentComponent = () => {
    if (loading && campaignExecutionList.length === 0) return <Loading />;

    if (!loading && campaignExecutionList.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum atendimento encontrado.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {campaignExecutionList.map((execution) => (
            <CampaignExecutionCard
              key={execution.id}
              execution={execution}
              refetch={() => getCampaignExecutionList({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Heading>Atendimentos</Heading>
      </Flex>

      {getCurrentComponent()}

      {showAllPendingExecutionsDialog && pendingExecutionDetails?.last_disposition_date_time && (
        <AllPendingExecutionDialog
          pendingExecutionDetails={pendingExecutionDetails}
          handleClose={closeAllPendingExecutionsDialog}
        />
      )}
    </Box>
  );
};

export default CampaignExecution;
